"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPersonalEditorialCategoryOrPage = void 0;
var _fetching = require("@ori/fetching");
var _queriesNet = require("../queries-net");
var _utils = require("../utils");
/* istanbul ignore file @preserve -- API */

/**
 * Fetch function that fetches data for personal editorial category or personal landing page from GraphQL.
 */
const getPersonalEditorialCategoryOrPage = async ({
  graphQlUrl,
  headers,
  pageId,
  previewMode,
  landingPageId,
  includeRoot,
  includeThemeItems
}) => {
  const data = await (0, _fetching.fetchGraphql)({
    query: _queriesNet.personalEditorialCategoryOrPageQuery,
    url: graphQlUrl,
    variables: {
      pageId,
      landingPageId,
      includeRoot,
      includeThemeItems
    },
    headers: {
      ...headers,
      [_fetching.PREVIEW_MODE]: previewMode ?? false
    },
    ...(previewMode ? {
      timeout: 30000
    } : null)
  });
  const {
    personalEditorialLandingPage,
    personalEditorialPage,
    rootPersonalEditorialLandingPage
  } = data.application ?? {};
  return {
    application: {
      editorialLandingPage: {
        ...personalEditorialLandingPage,
        __typename: 'EditorialLandingPage',
        landingPageId: personalEditorialLandingPage?.landingPageId ?? '',
        themeItems: (0, _utils.filterOutCurrentCategory)({
          pageId,
          // Use rootPersonalEditorialLandingPage for non-landing pages
          categories: landingPageId ? rootPersonalEditorialLandingPage?.themeItems : personalEditorialLandingPage?.themeItems
        }).map(category => ({
          ...category,
          __typename: 'EditorialLandingPage'
        }))
      },
      editorialPage: personalEditorialPage
    }
  };
};
exports.getPersonalEditorialCategoryOrPage = getPersonalEditorialCategoryOrPage;
